const drawerWidth = 60;
const styles = (theme) => ({
  root: {
    display: "flex",
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),

    display: "flex",
    flexDirection: "row",
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginLeft: 6,
    marginRight: 36,
  },
  hide: {
    display: "none",
  },
  drawer: {
    marginTop: "2rem",
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "0 8px",
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    paddingLeft: drawerWidth,
    [theme.breakpoints.down('lg')]: {
      padding: "0",
    },
  },
  appBarWrapper:{
    paddingLeft:"16px",
    paddingRight:"16px",
  },
});

export default styles;